import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=0544ac25&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"
import style0 from "./topic.vue?vue&type=style&index=0&id=0544ac25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544ac25",
  null
  
)

export default component.exports